// Atualização ao vivo das listas (pedido 2026-10-03: "tenho que ficar dando
// F5 pra ver o veículo/usuário novo, e os outros funcionários também").
//
// Toda gravação que deu certo (apiRequest → Traccar, fetchWithAuth → GPS
// Drive Backend) passa por reportWrite(). Se o caminho mexe em veículos ou
// usuários, avisa os ouvintes (use-live-sync.ts), que recarregam a lista
// desta aba e mandam o aviso pras outras telas abertas da empresa. Módulo
// sem dependências de propósito: os dois clientes HTTP importam daqui, e
// daqui não importa nenhum deles (sem import circular).

export type LiveSyncTopic = "vehicles" | "users";

type Rule = { pattern: RegExp; topics: LiveSyncTopic[] };

// Caminhos do Traccar (api.gpsdrive.com.br/api/...).
const TRACCAR_RULES: Rule[] = [
  { pattern: /^\/api\/devices(\/|$)/, topics: ["vehicles"] },
  { pattern: /^\/api\/users(\/|$)/, topics: ["users"] },
  { pattern: /^\/api\/permissions(\/|$)/, topics: ["vehicles", "users"] },
];

// Caminhos do GPS Drive Backend (/api/v1/...). Lista do que realmente muda
// a lista de veículos/usuários — POST /users/summary, por exemplo, é só
// leitura, e fatura/documento/sessão não mudam linha nenhuma da lista.
const GPSDRIVE_RULES: Rule[] = [
  { pattern: /^\/api\/v1\/vehicle-metadata(\/|$)/, topics: ["vehicles"] },
  { pattern: /^\/api\/v1\/vehicle-trash(\/|$)/, topics: ["vehicles"] },
  { pattern: /^\/api\/v1\/vehicles\/[^/]+\/name$/, topics: ["vehicles"] },
  { pattern: /^\/api\/v1\/permissions\//, topics: ["vehicles", "users"] },
  { pattern: /^\/api\/v1\/users$/, topics: ["users"] },
  {
    pattern: /^\/api\/v1\/users\/[^/]+\/(role|account-type|suspended|client-profile|avatar|trust-access)$/,
    topics: ["users"],
  },
  { pattern: /^\/api\/v1\/sub-users(\/|$)/, topics: ["users"] },
  { pattern: /^\/api\/v1\/user-deletions(\/|$)/, topics: ["users"] },
  { pattern: /^\/api\/v1\/companies\/reseller$/, topics: ["users"] },
];

type Listener = (topics: LiveSyncTopic[]) => void;
const listeners = new Set<Listener>();

export function onLocalWrite(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function reportWrite(source: "traccar" | "gpsdrive", method: string | undefined, path: string): void {
  if (!method || method.toUpperCase() === "GET" || listeners.size === 0) return;
  const cleanPath = path.split("?")[0];
  const rules = source === "traccar" ? TRACCAR_RULES : GPSDRIVE_RULES;
  const topics = new Set<LiveSyncTopic>();
  for (const rule of rules) {
    if (rule.pattern.test(cleanPath)) for (const t of rule.topics) topics.add(t);
  }
  if (topics.size === 0) return;
  for (const listener of listeners) listener([...topics]);
}
